import { Button, Divider, Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { DataGrid } from '@mui/x-data-grid';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { BillsFontIcon } from '../../components/CustomIcons';
import CustomSection from '../../components/CustomSection';
import CustomTable from '../../components/CustomTable';
import { paths } from '../../config/router.config';
import theme, { commonFont } from '../../theme.css';
import {orange} from '@mui/material/colors';

const useStyles = makeStyles((theme) => ({
    main: {
        padding: theme.spacing(2),
        background: theme.palette.common.white,
    },
    box: {
        background: orange[500],
        color: theme.palette.common.white,
        padding: theme.spacing(2, 3),
        borderRadius: theme.spacing(0.5)
    },
    text_normal: {
        fontFamily: commonFont.regular,
    },
    section: {
        padding: theme.spacing(2),
        borderRadius: theme.spacing(0.5),
        border: '1px solid #ccc'
    }
}));

export default function BillDetailView(props){
    const classes = useStyles();
    const {t} = useTranslation();
    const history = useHistory();

    const [detail, setDetail] = useState(null);
    const { location } = props;

    useEffect(() => {
        if(location && location.state && location.state.detail) {
            setDetail(location.state.detail);
        }
    }, []);

    const columns = [
        { field: 'id', name: 'Service'},
        { field: 'description', name: 'Description'},
        { field: 'type', name: 'Type'},
        { field: 'net_amout', name: 'Net Amount'},
        { field: 'discount_amount', name: 'Discount Amount'},
        { field: 'discount', name: 'Discount'},
        { field: 'tax_amount', name: 'TAX Amount', },
        { field: 'total', name: 'Total', },
    ];
    const totals = [
        { name: 'bill_debit', value: 0},
        { name: 'bill_credit', value: 0},
        { name: 'billed', value: 0},
        { name: 'bill_amount', value: 0},
    ]

    return (
        <Grid item xs={12} className={classes.main}>
            <CustomSection notMarginTop={true} 
                title={t('bill_detail')} 
                icon={<BillsFontIcon style={{
                    color: theme.palette.common.white,
                }}/>}
            >
                <Grid item xs={12} sm={4} marginTop={1} className={classes.box}>
                    <Typography variant='body2'>{t('bill_period')} <span className={classes.text_normal}>{' 01/01/2022 - 01/02/2022'}</span></Typography>
                    <Typography variant='body2'>{t('bill_due_date')} <span className={classes.text_normal}>{' 03/12/2021'}</span></Typography>
                </Grid>
                <Grid item xs={12} marginTop={1} container direction='row' spacing={1}>
                    <Grid item xs={12} sm={9}>
                        {/* <CustomSection notMarginTop={true} 
                            title={t('bill_credits_debits')}
                        >
                            <CustomTable 
                                showHeader={true}
                                rows={detail}
                                columns={columns}
                            />
                        </CustomSection> */}
                        <Grid item xs={12} className={classes.section}>
                            <Grid item xs={12}>
                                <Typography variant='body2'>{t('bill_credits_debits')}</Typography>
                            </Grid>
                            <Divider style={{marginTop: 5, marginBottom: 5}}/>
                            <Grid item xs={12}>
                                <CustomTable 
                                    showHeader={true}
                                    rows={detail}
                                    columns={columns}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        {/* <CustomSection notMarginTop={true} 
                            title={t('bill_totals')}
                        >
                            {totals && totals.length > 0 && totals.map((item, index) => {
                                return (
                                    <Grid item xs={12} container direction='row' spacing={1}>
                                        <Grid item xs={6}>
                                            <Typography variant='body2'>{t(item.name)}</Typography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Typography>{item.value ? item.value.toFixed(2) : '0.00'}</Typography>
                                        </Grid>
                                    </Grid>
                                );
                            })}
                        </CustomSection> */}
                        <Grid item xs={12} className={classes.section}>
                            <Grid item xs={12}>
                                <Typography variant='body2'>{t('bill_totals')}</Typography>
                            </Grid>
                            <Divider style={{marginTop: 5, marginBottom: 5}}/>
                            <Grid item xs={12}>
                                {totals && totals.length > 0 && totals.map((item, index) => {
                                    return (
                                        <Grid item xs={12} container direction='row' spacing={1}>
                                            <Grid item xs={6}>
                                                <Typography variant='body2'>{t(item.name)}</Typography>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Typography>{item.value ? item.value.toFixed(2) : '0.00'}</Typography>
                                            </Grid>
                                        </Grid>
                                    );
                                })}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </CustomSection>
        </Grid>
    );
}